import { configureStore, combineReducers } from "@reduxjs/toolkit";
import logger from "redux-logger";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import characteristicValueReducer from "./reducer/characteristic_value";
import characteristicTypeReducer from "./reducer/characteristic_type";
import fiscalConditionReducer from "./reducer/fiscal_condition";
import documentTypeReducer from "./reducer/document_type";
import categoryTypeReducer from "./reducer/category_type";
import categoryReducer from "./reducer/category";
import catalogReducer from "./reducer/catalog";
import sidebarReducer from "./reducer/sidebar";
import profileReducer from "./reducer/profile";
import personReducer from "./reducer/person";
import authReducer from "./reducer/auth";
import userReducer from "./reducer/user";
import logsReducer from "./reducer/logs";
import permissionReducer from "./reducer/permission";

// API-ORDER-MANAGEMENT
import orderReducer from "./reducer/api-order-management/order";

// API-PERSON-MANAGEMENT
import paisReducer from "./reducer/api-person-management/country";
import personCharacteristicTypeReducer from "./reducer/api-person-management/characteristic_type";
import personFiscalConditionReducer from "./reducer/api-person-management/fiscal_condition";
import personDocumentTypeReducer from "./reducer/api-person-management/document_type";
import personRolesReducer from "./reducer/api-person-management/roles";

// API-CATALOG-MANAGEMENT
import priceListReducer from "./reducer/api-catalog-management/price_list";
import priceUpdateReducer from "./reducer/api-catalog-management/price_update";
import productReducer from "./reducer/api-catalog-management/product";

const persistConfig = {
  key: "smart360",
  storage,
  version: 0,
  debug: false,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  characteristic_values: characteristicValueReducer,
  characteristic_type: characteristicTypeReducer,
  fiscal_condition: fiscalConditionReducer,
  document_type: documentTypeReducer,
  category_type: categoryTypeReducer,
  category: categoryReducer,
  catalog: catalogReducer,
  sidebar: sidebarReducer,
  profile: profileReducer,
  product: productReducer,
  person: personReducer,
  auth: authReducer,
  user: userReducer,
  logs: logsReducer,
  permission: permissionReducer,

  // API-ORDER-MANAGEMENT
  order: orderReducer,

  // API-PERSON-MANAGEMENT
  characteristic_type_person: personCharacteristicTypeReducer,
  fiscal_condition_person: personFiscalConditionReducer,
  document_type_person: personDocumentTypeReducer,
  pais: paisReducer,
  roles: personRolesReducer,

  // API-CATALOG-MANAGEMENT
  price_list: priceListReducer,
  price_update: priceUpdateReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const IS_DEV = process.env.NODE_ENV !== "production";

const store = configureStore({
  reducer: persistedReducer,
  devTools: IS_DEV,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });

    if (IS_DEV) {
      middleware.push(logger);
    }

    return middleware;
  },
});

export const persistor = persistStore(store);

export default store;
